import { useTranslation } from 'react-i18next'
import cn from 'classnames/bind'

import Tooltip from 'app/common/ui/Tooltip'
import ConfirmationDialog from 'app/common/components/Confirmation/ConfirmationDialog'
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
import PlainIcon, { iconType, iconColor } from 'app/common/ui-next/plain-icon'

import styles from './PersonalLimit.module.scss';


const cx = cn.bind(styles)

type Props = {
  currency: string
  personalLimit: string | null | Array<unknown>
  onClearLimit: () => void
}

export const PersonalLimit = ({ currency, personalLimit, onClearLimit }: Props) => {
  const { t } = useTranslation('cafeteria')

  const limitNone = !personalLimit
  const limitActive = !limitNone

  const singleLimit = !(personalLimit instanceof Array)

  return (
    <div className={styles.limitTitle}>
      {`${t('settings_limit_personal_label', 'Лимит расходов на личные покупки')}:`}

      {singleLimit
        && <span className={cx({ limitActive, limitNone })}>
          {'\u00A0'}
          {limitActive
            ? `${personalLimit} ${t('settings_limit_units', { currency })}`
            : t('settings_limit_absent', 'Отсутствует')}
        </span>}

      {limitActive
        && singleLimit
        && <ConfirmationDialog
          onConfirm={onClearLimit}
          text={t('settings_limit_personal_delete_prompt', 'Удалить собственный лимит на личные покупки?')}
          confirmButtonText={t('settings_limit_personal_delete_confirm', 'Да')}
          cancelButtonText={t('settings_limit_personal_delete_cancel', 'Отмена')}
        >
          {handleConfirm => (
            <Tooltip className={styles.crossTooltip} text={t('settings_limit_personal_delete_tooltip', 'Снять ограничение')}>
              <PlainButtonAsLink onClick={handleConfirm}>
                <PlainIcon
                  type={iconType.LIGHT_CROSS}
                  color={iconColor.COLOR_GRAY}
                  className={styles.cross}
                  width={16}
                  height="auto"
                />
              </PlainButtonAsLink>
            </Tooltip>
          )}
        </ConfirmationDialog>}
    </div>
  )
}
